import get from 'lodash/get';
import { MICRO_SITE_ENDPOINTS } from 'consts';
import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { questionsToMap } from 'utils/formValuesUtils';
import {
  getQuestionOptionsPayload,
  GetQuestionOptionsParsedResponse,
  GetQuestionOptionsRawResponse,
} from 'types';

import { triadSuperFetch } from 'utils/superFetch';

/**
 * @summary given the current state of the form and the current school we may need to get options for a question
 */
export async function getQuestionOptions(
  payload: getQuestionOptionsPayload,
  schoolCode: string,
  variant: string,
  endpoint = MICRO_SITE_ENDPOINTS.QUESTION_OPTIONS_ENDPOINT,
  pageTaxonomyValues = {}
): Promise<GetQuestionOptionsParsedResponse> {
  const replies = get(payload, 'questionReplies', []).map(
    ({ questionAnswer, questionId }) => ({
      questionAnswer,
      questionId,
    })
  );

  const neededOptions = get(payload, 'requestedOptions', []);
  const endpointUrl = `${TRIAD_PROXY_ROUTE}${endpoint}`;

  const [apiError, apiResponse] =
    await triadSuperFetch<GetQuestionOptionsRawResponse>(endpointUrl, {
      method: 'POST',
      timeout: 10000,
      body: {
        schoolCode,
        templateName: variant,
        requestedOptions: neededOptions,
        questionReplies: replies,
        pageTaxonomyValues,
      },
      retry: {
        maxAttempts: 3,
        waitTimeBetweenFails: 1000,
      },
    });

  if (apiError) {
    throw apiError;
  }

  return questionsToMap(apiResponse.questions);
}
